import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// // 需要左方向动画的路由用this.$router.to('****')
// Router.prototype.togo = function (path) {
//   this.isleft = true
//   this.isright = false
//   this.push(path)
// }
// // 需要右方向动画的路由用this.$router.goRight('****')
// Router.prototype.goRight = function (path) {
//   this.isright = true
//   this.isleft = false
//   this.push(path)
// }
// // 需要返回按钮动画的路由用this.$router.goBack()，返回上一个路由
// Router.prototype.goBack = function () {
//   this.isright = true
//   this.isleft = false
//   this.go(-1)
// }
// // 点击浏览器返回按钮执行，此时不需要路由回退
// Router.prototype.togoback = function () {
//   this.isright = true
//   this.isleft = false
// }
// // 点击浏览器前进按钮执行
// Router.prototype.togoin = function () {
//   this.isright = false
//   this.isleft = true
// }

export const constantRoutes = [
  {
    path: '/live',
    name: 'live',
    component: () => import('@/pages/live/live'),
    meta: { title: '直播互动' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/pages/privacy/privacy'),
    meta: { title: '隐私政策' }
  },
  {
    path: '/cyxaprivacy',
    name: 'cyxaprivacy',
    component: () => import('@/pages/privacy/cyxaprivacy'),
    meta: { title: '隐私政策' }
  },
  {
    path: '/sdkDetails',
    name: 'sdkDetails',
    component: () => import('@/pages/privacy/sdkDetails'),
    meta: { title: '第三方Sdk详情' }
  },
  {
    path: '/legalNotices',
    name: 'legalNotices',
    component: () => import('@/pages/privacy/legalNotices'),
    meta: { title: '用户协议' }
  },
  {
    path: '/guidePage',
    name: 'guidePage',
    component: () => import('@/pages/guidePage/guidePage'),
    meta: { title: '秦探APP' }
  },
  {
    path: '/cyxa',
    name: 'cyxa',
    component: () => import('@/pages/guidePage/cyxa'),
    meta: { title: '畅游西安APP' }
  },
  {
    path: '/',
    name: 'Gps',
    component: () => import('@/pages/Gps'),
    meta: {
      title: ''
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/pages/detail'),
    meta: {
      title: '景区详情'
    }
  },
  {
    path: '/mapDetail',
    name: 'mapDetail',
    component: () => import('@/pages/mapDetail'),
    meta: {
      title: '景点详情'
    }
  },
  {
    path: '/gpsdetail/navigation',
    name: 'navigation',
    component: () => import('@/pages/gpsDetail/navigation.vue'),
    meta: {
      title: '高德地图'
    }
  }
]

export const asyncRoutes = []

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL === 'PRO' ? '/gisweb/' : '',
//   routes: [
//     // {
//     //   path: '/',
//     //   name: 'index',
//     //   component: (resolve) => require(['@/pages/index'], resolve),
//     //   meta: {
//     //     title: '景区导览'
//     //   }
//     // },
//     // 20220928 直播互动
//     {
//       path: '/live',
//       name: 'live',
//       component: () => import('@/pages/live/live'),
//       meta: { title: '直播互动' }
//     },
//     {
//       path: '/',
//       name: 'Gps',
//       component: () => import('@/pages/Gps'),
//       meta: {
//         title: '景区导览'
//       }
//     },
//     {
//       path: '/detail',
//       name: 'detail',
//       component: () => import('@/pages/detail'),
//       meta: {
//         title: '景区详情'
//       }
//     },
//     {
//       path: '/mapDetail',
//       name: 'mapDetail',
//       component: () => import('@/pages/mapDetail'),
//       meta: {
//         title: '景点详情'
//       }
//     },
//     {
//       path: '/gpsdetail/navigation',
//       name: 'navigation',
//       component: () => import('@/pages/gpsDetail/navigation.vue'),
//       meta: {
//         title: '高德地图'
//       }
//     }
//     // {
//     //   path: '/gps',
//     //   name: 'gps',
//     //   component: (resolve) => require(['@/pages/gps'], resolve),
//     //   meta: {
//     //     title: '景区导览'
//     //   }
//     // },
//     // {
//     //   path: '/survey',
//     //   name: 'survey',
//     //   component: (resolve) => require(['@/pages/survey'], resolve),
//     //   meta: {
//     //     title: '景区概况'
//     //   }
//     // }, {
//     //   path: '/detail_gps',
//     //   name: 'detail_gps',
//     //   component: (resolve) => require(['@/pages/detail_gps'], resolve),
//     //   meta: {
//     //     title: '景点详情'
//     //   }
//     // }, {
//     //   path: '/detail_zb',
//     //   name: 'detail_zb',
//     //   component: (resolve) => require(['@/pages/detail_zb'], resolve)
//     // },
//     // {
//     //   path: '/scan',
//     //   name: 'scan',
//     //   component: (resolve) => require(['@/pages/scan'], resolve),
//     //   meta: {
//     //     title: '扫码导览'
//     //   }
//     // }, {
//     //   path: '/detail_scan',
//     //   name: 'detail_scan',
//     //   component: (resolve) => require(['@/pages/detail_scan'], resolve),
//     //   meta: {
//     //     title: '景点详情'
//     //   }
//     // }, {
//     //   path: '/vr',
//     //   name: 'vr',
//     //   component: (resolve) => require(['@/pages/vr'], resolve),
//     //   meta: {
//     //     title: 'VR导览'
//     //   }
//     // }, {
//     //   path: '/detail_vr',
//     //   name: 'detail_vr',
//     //   component: (resolve) => require(['@/pages/detail_vr'], resolve),
//     //   meta: {
//     //     title: 'VR景点详情'
//     //   }
//     // },
//     // {
//     //   path: '/gpsdetail/navigation',
//     //   name: 'navigation',
//     //   component: (resolve) => require(['@/pages/gpsDetail/navigation.vue'], resolve),
//     //   meta: {
//     //     title: '高德地图'
//     //   }
//     // }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js